import { datadogLogs } from '@datadog/browser-logs'
import { Datacenter, datadogRum } from '@datadog/browser-rum'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

const hasWindow = typeof window !== 'undefined'

export const getEnvironmentFromURL = (hostname: string): string => {
  if (hostname === 'www.cinch.co.uk') {
    return 'production'
  }
  if (hostname === 'www-uat.cinch.co.uk') {
    return 'uat'
  }
  if (hostname === 'cambridge.preview.aws.cinch.co.uk') {
    return 'cambridge'
  }
  if (hostname.includes('.feature.')) {
    return hostname.split('.')[0]
  }
  return hostname
}

export const initDataDogLogging = (): void => {
  if (hasWindow) {
    const clientToken = `${getEnv(Env.DataDogClientId)}`
    const currentEnv = getEnvironmentFromURL(window.location.hostname)

    datadogLogs.init({
      clientToken,
      datacenter: 'eu',
      forwardErrorsToLogs: true,
    })

    datadogLogs.addLoggerGlobalContext('env', currentEnv)

    const applicationId = `${getEnv(Env.DataDogRumApplicationId)}`
    const datadogRumclientToken = `${getEnv(Env.DataDogRumClientToken)}`
    datadogRum.init({
      applicationId,
      clientToken: datadogRumclientToken,
      datacenter: Datacenter.EU,
      sampleRate: 100,
      env: currentEnv,
      trackInteractions: true,
    })
  }
}
